import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authActions } from './auth';

interface VaultiLakeState {
  selectedCustomerId: string | null;
  selectedClientId: string | null;
  selectedOntologyId: string | null;
}

const initialState: VaultiLakeState = {
  selectedCustomerId: null,
  selectedClientId: null,
  selectedOntologyId: null,
};

const vaultiLakeSlice = createSlice({
  name: 'vaultiLake',
  initialState,
  reducers: {
    setLakehouseSelection(state, action: PayloadAction<{ customerId: string | null; clientId: string | null }>) {
      const scopeChanged =
        state.selectedCustomerId !== action.payload.customerId || state.selectedClientId !== action.payload.clientId;
      state.selectedCustomerId = action.payload.customerId;
      state.selectedClientId = action.payload.clientId;
      if (scopeChanged) {
        state.selectedOntologyId = null;
      }
    },
    clearLakehouseSelection(state) {
      state.selectedCustomerId = null;
      state.selectedClientId = null;
      state.selectedOntologyId = null;
    },
    setOntologySelection(state, action: PayloadAction<string | null>) {
      state.selectedOntologyId = action.payload;
    },
    clearOntologySelection(state) {
      state.selectedOntologyId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logout, () => {
      return initialState;
    });
  },
});

export const { setLakehouseSelection, clearLakehouseSelection, setOntologySelection, clearOntologySelection } =
  vaultiLakeSlice.actions;
export default vaultiLakeSlice.reducer;
